import { Text, Flex } from 'vvs-uikit'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'contexts/Localization'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import { QuestButtonProps } from 'views/VvsGotchi/components/QuestButton/types'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { NotOnboardedLabel, DailyResetLabel } from 'views/VvsGotchi/components/QuestButton/Labels'
import { getVvsGotchiQuestDetailPath } from 'config/constants/paths'
import { questSymbolToImageUrl } from 'views/VvsGotchi/config'
import { moleDashInfoFromOwner } from 'state/vvsgotchi/quests/moleDash'
import { questSymbolId } from 'views/VvsGotchi/utils/quest'

import { MOLE_DASH_MAX_EXP } from '../config'

import ExpStars from './ExpStars'
import { MoleDashQuestBlockButton } from './styles'

const MoleDashQuestButton: React.FC<QuestButtonProps> = ({ quest, title, imageUrl }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { isOnboarded, owner } = useGotchiOwner()

  const onboardToUnlock = !isOnboarded
  const moleDashInfo = moleDashInfoFromOwner(owner)

  return (
    <MoleDashQuestBlockButton
      grayout={onboardToUnlock}
      onClick={() => {
        history.push(getVvsGotchiQuestDetailPath(questSymbolId(quest.symbol)))
      }}
    >
      {onboardToUnlock ? (
        <NotOnboardedLabel />
      ) : (
        (moleDashInfo.todayExp >= MOLE_DASH_MAX_EXP || quest.isCompleted) && <DailyResetLabel />
      )}

      <PixelatedImage
        src={imageUrl ?? questSymbolToImageUrl[quest.symbol] ?? '/images/vvsGotchi/mole_controller.png'}
        width="150px"
        my={4}
      />

      <Flex background="black" alignSelf="stretch" p={2}>
        <Flex flex="1" justifyContent="space-between" p={1}>
          <Text color="white" fontWeight="600">
            {title ?? quest.name}
          </Text>
          <Flex flexDirection="column" alignItems="end">
            <ExpStars exp={moleDashInfo.todayExp} />
            <Text color="white" fontSize="13px" fontWeight="700">
              {t('Max +%maxExp% per day', { maxExp: MOLE_DASH_MAX_EXP })}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </MoleDashQuestBlockButton>
  )
}

export default MoleDashQuestButton
